import http from '../clients/Axios'

export default class StockOpnameService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const res = await http.get(
      `/stock/opname/paginate?page[number]=${pageNumber}&page[size]=${pageSize}&sort=${sort}${filters_param}&timestamp=${new Date().getTime()}`
    )

    return res.data
  }

  async get(param) {
    param = param ? param : ''
    const res = await http.get(`/stock/opname${param}`)
    return res
  }

  async add(form) {
    const res = await http.post('/stock/opname', form)
    return res
  }

  async update(form) {
    const res = await http.put(`/stock/opname/${form.id}`, form)
    return res
  }

  async addPabrik(form) {
    const res = await http.put(`/stock/opname/${form.id}`, form)
    return res
  }

  async delete(id, obat_id) {
    const res = await http.delete(`/stock/opname/${id}/${obat_id}`)
    return res
  }

  async export(sortField, sortOrder, filters) {
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const unixTime = Math.floor(Date.now() / 1000)
    return http({
      url: `/stock/opname/export?sort=${sort}${filters_param}&t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async download(id) {
    const unixTime = Math.floor(Date.now() / 1000)
    return http({
      url: `/stock/opname/${id}/export?t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async template() {
    return http({
      url: `/stock/opname/template/download`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async upload(id, value) {
    let formData = new FormData()

    if (value) {
      formData.append('file_opname', value)
    }

    return await http.post(`/stock/opname/${id}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }
}
